import React from "react";

const STYLES = {
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  Missing: "bg-slate-100 text-slate-600 border-slate-200",
  Rejected: "bg-rose-50 text-rose-700 border-rose-200",
  "Approval pending": "bg-amber-50 text-amber-700 border-amber-200",
  Complete: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "In progress": "bg-violet-50 text-violet-700 border-violet-200",
  Locked: "bg-slate-100 text-slate-500 border-slate-200",
  Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Processing: "bg-sky-50 text-sky-700 border-sky-200",
  "Needs Correction": "bg-orange-50 text-orange-700 border-orange-200",
  Open: "bg-amber-50 text-amber-700 border-amber-200",
  "In Progress": "bg-violet-50 text-violet-700 border-violet-200",
  Resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export default function StatusBadge({ status, className = "" }) {
  const style = STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${style} ${className}`}
    >
      {status}
    </span>
  );
}
